// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"open-body_wrapper__HO0RO","content":"open-body_content__TYWj2","list":"open-body_list___VF6z"};